// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3bQvN","colCheckbox":"styles_colCheckbox__1yGmw"};